<div style="float: right;">
    <mat-icon style="cursor: pointer;" (click)="closeModal()">close</mat-icon>
</div>
<div [formGroup]="resetPasswordForm" style="padding: 0 2em 2em 2em; display: flex; flex-direction: column; width: 100%;">
    <div style="display: flex;flex-direction: row; gap: 1em;">
        <mat-form-field appearance="outline" style="width: 100%;">
            <mat-label>Password</mat-label>   
            <input matInput formControlName="password">
        </mat-form-field>
    </div>
    <button mat-raised-button color="primary" [disabled]="resetPasswordForm.invalid" (click)="resetPassword()">Reset Password</button>
</div>
